import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { ATS_PUBLIC_APP_PATH } from "@av/apps/recruitment/ats-common/routes/jobs/jobs.route-config";
import { QUERY_PARAMS } from "@av/apps/recruitment/ats-common/routes/jobs/query-params";
import { Button } from "@av/components/atoms/Button";
import { isSupportedLocale } from "@av/components/organisms/editor/localized-text-editor/text-editor-supported-locales";
import { NotFoundPage } from "@av/components/templates/layouts/errors/types/NotFoundPage";
import { useNoIndex } from "../../hooks/useNoIndex";
import { FilterSearchParamMapper } from "../../pages/jobs/hooks/search-params-mapper";

export function PublicNotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const pathNames = location.pathname.split("/").filter(Boolean);
  const jobsPathIndex = pathNames.indexOf(ATS_PUBLIC_APP_PATH);
  const companyId = jobsPathIndex >= 0 ? pathNames[jobsPathIndex + 1] : undefined;
  const hasCompany = Boolean(companyId && companyId !== "not_found");
  const returnSearchParams = new FilterSearchParamMapper(location.search).urlSearchParams;
  const allowedSearchParams = new Set<string>([
    QUERY_PARAMS.locale,
    ...Object.values(QUERY_PARAMS.jobBoard),
  ]);

  if (!isSupportedLocale(returnSearchParams.get(QUERY_PARAMS.locale) ?? "")) {
    returnSearchParams.delete(QUERY_PARAMS.locale);
  }

  for (const key of [...returnSearchParams.keys()]) {
    if (!allowedSearchParams.has(key)) {
      returnSearchParams.delete(key);
    }
  }

  returnSearchParams.sort();

  useNoIndex();

  return (
    <NotFoundPage
      ctaButton={
        <Button
          type="primary"
          onClick={() =>
            navigate({
              pathname: hasCompany ? `/${ATS_PUBLIC_APP_PATH}/${companyId}` : location.pathname,
              search: hasCompany ? returnSearchParams.toString() : "",
            })
          }
          testIdPrefix="go-back-to-job"
        >
          {t("recruitment.jobs.publicNotFoundPage_goBackToJobs")}
        </Button>
      }
      message={t("recruitment.jobs.publicNotFoundPage_message")}
      showGoBackButton={false}
      title={t("recruitment.jobs.publicNotFoundPage_title")}
    />
  );
}
